import { AccidentAtlasTileView } from '../types/tile'

export type AccidentAtlasTileRow = {
  columns: 2 | 3
  tiles: AccidentAtlasTileView[]
}

const TEXT_ROW_SIZES = [3, 2] as const

function partitionTextTileRows(
  textTiles: AccidentAtlasTileView[]
): AccidentAtlasTileRow[] {
  const rows: AccidentAtlasTileRow[] = []
  let index = 0
  let patternIndex = 0

  while (index < textTiles.length) {
    const rowSize = TEXT_ROW_SIZES[patternIndex % TEXT_ROW_SIZES.length]
    const chunk = textTiles.slice(index, index + rowSize)

    if (chunk.length === 0) {
      break
    }

    rows.push({
      columns: chunk.length >= 3 ? 3 : 2,
      tiles: chunk,
    })

    index += chunk.length
    patternIndex += 1
  }

  return rows
}

function partitionChartTileRows(
  chartTiles: AccidentAtlasTileView[]
): AccidentAtlasTileRow[] {
  const rows: AccidentAtlasTileRow[] = []

  for (let index = 0; index < chartTiles.length; index += 2) {
    rows.push({
      columns: 2,
      tiles: chartTiles.slice(index, index + 2),
    })
  }

  return rows
}

export function partitionAccidentAtlasTileRows(
  tiles: AccidentAtlasTileView[]
): AccidentAtlasTileRow[] {
  const textTiles = tiles.filter((tile) => tile.displayKind === 'text')
  const chartTiles = tiles.filter((tile) => tile.displayKind !== 'text')

  return [
    ...partitionTextTileRows(textTiles),
    ...partitionChartTileRows(chartTiles),
  ]
}

export const INITIAL_VISIBLE_ROWS = 3
export const LOAD_MORE_ROW_COUNT = 3

export function sliceTileRows(
  rows: AccidentAtlasTileRow[],
  visibleRowCount: number
): AccidentAtlasTileRow[] {
  return rows.slice(0, visibleRowCount)
}

export function hasMoreTileRows(
  rows: AccidentAtlasTileRow[],
  visibleRowCount: number
): boolean {
  return rows.length > visibleRowCount
}
